import { MinusIcon, PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";

const QuantityStepper = ({
  serviceName,
  quantity,
  handleIncrease,
  handleDecrease,
  onRemove,
  pricePerUnit,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between bg-white shadow rounded-xl p-4 mb-4">
      {/* Left: Service Info */}
      <div className="flex flex-col basis-1/3 break-words">
        <span className="font-medium text-ink-800">{serviceName}</span>
        <span className="text-sm text-ink-500">${pricePerUnit} / client</span>
      </div>

      {/* Center: Stepper */}
      <div className="flex items-center justify-center basis-1/3 space-x-2">
        <button
          type="button"
          onClick={handleDecrease}
          disabled={quantity === 1}
          className="p-1 rounded-full border border-ink-200 hover:bg-cream-200 disabled:opacity-50"
        >
          <MinusIcon className="h-4 w-4 text-ink-600" />
        </button>

        <span className="min-w-[24px] text-center font-semibold text-ink-700">
          {quantity}
        </span>

        <button
          type="button"
          onClick={handleIncrease}
          className="p-1 rounded-full border border-ink-200 hover:bg-cream-200"
        >
          <PlusIcon className="h-4 w-4 text-ink-600" />
        </button>
      </div>

      {/* Right: Remove */}
      <div className="flex justify-end basis-1/3">
        <button
          type="button"
          onClick={onRemove}
          className="ml-auto p-1 text-signal-red-500 hover:text-signal-red-700"
          aria-label="Remove service"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default QuantityStepper;
